import { createSelector } from 'reselect';
import RouteModificationTransactionsColumns from '../../containers/RouteModificationTransactionsColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.ROUTE_MODIFICATION_TRANSACTIONS.isLoading;
export const getData = TableDefinitions.ROUTE_MODIFICATION_TRANSACTIONS.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.global.assetType.appContext,
  RouteModificationTransactionsColumns,
);
